export default "__VITE_ASSET__052d687c__"